import { createFileRoute, Outlet } from '@tanstack/react-router';
import { SupportTicketsPage } from '@/pages/support-tickets';
import { SupportTicketActionsProvider } from '@/pages/support-tickets/support-ticket-actions-context';
import { supportTicketsSearchSchema } from '@/routes/-shared/supportTicketsSearchSchema';

/**
 * Layout della sezione ticket: la coda resta montata e il dettaglio `/$id`
 * si apre sopra di lei sull'`Outlet`, come nella webapp: chiudere il
 * pannello torna alla lista con filtri e scorrimento di prima.
 *
 * Il provider sta qui e non nella pagina perche' i dialog di assegnazione e
 * conferma stato servono sia alla coda sia alla sheet, e devono esistere in
 * una copia sola.
 */
export const Route = createFileRoute('/admin/_layout/tickets/_layout')({
  component: SupportTicketsLayout,
  validateSearch: supportTicketsSearchSchema,
});

function SupportTicketsLayout() {
  return (
    <SupportTicketActionsProvider>
      <SupportTicketsPage />
      <Outlet />
    </SupportTicketActionsProvider>
  );
}
